import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

export default class extends Controller {
  create() {
    this.element.requestSubmit()
  }

  destroy() {
    TempFormHelper.addHiddenInput(this.element, "_method", "delete")
    this.element.requestSubmit()
  }

  update() {
    TempFormHelper.addHiddenInput(this.element, "_method", "put")
    this.element.requestSubmit()
  }
}
